import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Link } from "react-router-dom";
import { getLaunchReadiness } from "../utils/launchReadiness";

export default function LaunchReadinessChecklist({
  game,
  draftSettings,
  linkCopiedVersion = 0,
}) {
  void linkCopiedVersion;
  const { items, doneCount, total, allDone } = getLaunchReadiness(
    game,
    draftSettings,
  );

  return (
    <section className="app-settings-card app-settings-card--launch">
      <div className="app-launch-checklist__head">
        <h3 className="app-settings-card__title">Готов к запуску</h3>
        <span className="app-launch-checklist__progress">
          {doneCount}/{total}
        </span>
      </div>

      <p className="app-launch-checklist__intro">
        {allDone
          ? "Всё готово — можно отправлять ссылку команде."
          : "Проверьте пункты перед рассылкой ссылки сотрудникам."}
      </p>

      <ul className="app-launch-checklist__list">
        {items.map((item) => {
          const Icon = item.done
            ? CheckCircleOutlineIcon
            : RadioButtonUncheckedIcon;

          return (
            <li
              key={item.id}
              className={`app-launch-checklist__item${
                item.done ? " app-launch-checklist__item--done" : ""
              }`}
            >
              <Icon className="app-launch-checklist__icon" fontSize="small" />
              <div className="app-launch-checklist__content">
                <strong>{item.label}</strong>
                {!item.done && item.hint ? <p>{item.hint}</p> : null}
              </div>
            </li>
          );
        })}
      </ul>

      <p className="app-launch-checklist__footer">
        Инструкцию для сотрудников можно отправить вместе со ссылкой:{" "}
        <Link to="/dlya-sotrudnika">Инструкция для сотрудников</Link>
      </p>
    </section>
  );
}
